import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { RenewalBatch } from './renewal-batch.model';
import * as RenewalBatchActions from './renewal-batch.actions';

export const renewalBatchesFeatureKey = 'renewalBatches';

export interface State extends EntityState<RenewalBatch> {
  // additional entities state properties
}

export const adapter: EntityAdapter<RenewalBatch> = createEntityAdapter<RenewalBatch>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});


export const reducer = createReducer(
  initialState,
  on(RenewalBatchActions.addRenewalBatch,
    (state, action) => adapter.addOne(action.renewalBatch, state)
  ),
  on(RenewalBatchActions.upsertRenewalBatch,
    (state, action) => adapter.upsertOne(action.renewalBatch, state)
  ),
  on(RenewalBatchActions.addRenewalBatchs,
    (state, action) => adapter.addMany(action.renewalBatchs, state)
  ),
  on(RenewalBatchActions.upsertRenewalBatchs,
    (state, action) => adapter.upsertMany(action.renewalBatchs, state)
  ),
  on(RenewalBatchActions.updateRenewalBatch,
    (state, action) => adapter.updateOne(action.renewalBatch, state)
  ),
  on(RenewalBatchActions.updateRenewalBatchs,
    (state, action) => adapter.updateMany(action.renewalBatchs, state)
  ),
  on(RenewalBatchActions.deleteRenewalBatch,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(RenewalBatchActions.deleteRenewalBatchs,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(RenewalBatchActions.loadRenewalBatchs,
    (state, action) => adapter.setAll(action.renewalBatchs, state)
  ),
  on(RenewalBatchActions.clearRenewalBatchs,
    state => adapter.removeAll(state)
  ),
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
